import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const steps = [
  {
    num: '01', icon: <ConnectWithoutContactIcon sx={{ fontSize: 36, color: '#fff' }} />,
    title: 'Capture Every Enquiry',
    desc: 'All incoming leads from your website, social media, walk-ins and phone calls are automatically captured and stored in one place.',
    color: '#684df4',
  },
  {
    num: '02', icon: <ManageAccountsIcon sx={{ fontSize: 36, color: '#fff' }} />,
    title: 'Assign & Notify Counselors',
    desc: 'The system auto-assigns enquiries to the right counselor, sends them an instant notification, and kickstarts the follow-up sequence.',
    color: '#233098',
  },
  {
    num: '03', icon: <TrackChangesIcon sx={{ fontSize: 36, color: '#fff' }} />,
    title: 'Track & Convert',
    desc: 'Monitor every student\'s journey status. Move them through admission stages, collect documents and fees — all digitally.',
    color: '#0ea5e9',
  },
  {
    num: '04', icon: <EmojiEventsIcon sx={{ fontSize: 36, color: '#fff' }} />,
    title: 'Analyze & Improve',
    desc: 'Get actionable insights on what works. Improve counselor performance, course demand, and marketing ROI every admission cycle.',
    color: '#7c3aed',
  },
];

const HowItWorks = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, background: 'linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%)' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#684df4', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
          How It Works
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#141d38', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '2.6rem' } }}>
          From First Enquiry to Final Enrollment
        </Typography>
      </Box>

      <Box sx={{ position: 'relative' }}>
        {/* Connecting line */}
        <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'absolute', top: 36, left: '12.5%', right: '12.5%', height: 2, background: 'linear-gradient(90deg, #684df4, #233098, #0ea5e9, #7c3aed)', borderRadius: 1, zIndex: 0 }} />

        <Grid container spacing={4} sx={{ position: 'relative', zIndex: 1 }}>
          {steps.map((s, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Box sx={{ textAlign: 'center', px: 1 }}>
                {/* Circle icon */}
                <Box sx={{
                  width: 72, height: 72, borderRadius: '50%', bgcolor: s.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  mx: 'auto', mb: 3,
                  boxShadow: `0 12px 32px ${s.color}55`,
                  border: '4px solid #fff',
                }}>
                  {s.icon}
                </Box>
                <Box sx={{ display: 'inline-block', bgcolor: `${s.color}12`, borderRadius: '8px', px: 1.5, py: 0.3, mb: 1.5 }}>
                  <Typography sx={{ color: s.color, fontWeight: 800, fontSize: 12, fontFamily: "'Montserrat', sans-serif", letterSpacing: 1 }}>STEP {s.num}</Typography>
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#141d38', mb: 1.5, fontFamily: "'Montserrat', sans-serif", fontSize: '1rem' }}>{s.title}</Typography>
                <Typography sx={{ color: '#64748b', lineHeight: 1.75, fontFamily: "'Montserrat', sans-serif", fontSize: 14 }}>{s.desc}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default HowItWorks;
